import messagingService from "../api/messagingService";

export const setUserToken = (token) => ({
  type: "SET_USER_TOKEN",
  payload: { token },
});

export const setUser = (user) => ({
  type: "SET_USER",
  payload: { user },
});

export const setUserLanguage = (userLanguage) => ({
  type: "SET_USER_LANGUAGE",
  payload: { userLanguage },
});

export const setLoginProgress = (inProgress) => ({
  type: "SET_LOGIN_PROGRESS",
  payload: { inProgress },
});

export const setPresenceStatus = (body) => {
  return async (dispatch) => {
    const status = body && body.status;
    // Kullanıcı seçimi: online / busy / away (çevrimdışı menüde yok)
    if (!["online", "busy", "away"].includes(status)) {
      return;
    }
    let response = await messagingService.setPresenceStatus(body);
    if (response.status === 200) {
      dispatch({
        type: "SET_PRESENCE_STATUS",
        payload: body,
      });
    }
  };
};
